var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIntelLine = function SvgIntelLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 479 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M.183.952h478"
  })));
};

export { SvgIntelLine as ReactComponent };
export default __webpack_public_path__ + "3a80a8c13307120be2d821ece994bb3b.svg";